import { memo } from 'react'

import RichText from '@/components/elements/texts/richText'

const TextSection = ({ data, className }) => {
  const { title, text } = data

  return (
    <div className={className}>
      <h1>{title}</h1>
      <RichText content={text} />
    </div>
  )
}

export default memo(TextSection)
